const poll = {
  id: '59aaa23434400000',
  description: 'description of my excellent poll',
  name: 'Default Poll',
  surveySchema: {
    title: 'Default Poll',
    pages: [
      {
        name: 'page1',
        elements: [
          {
            type: 'text',
            name: 'q1',
            title: 'How are you feeling today?',
            isRequired: true,
          },
          {
            type: 'rating',
            name: 'q2',
            title: 'Rate your experience (1-5)',
            rateMin: 1,
            rateMax: 5,
          },
          {
            type: 'comment',
            name: 'q3',
            title: 'Any additional comments?',
          },
        ],
      },
    ],
  },
};

export default poll;
